<template>
  <div
    class="screen-privacy-policy has-tab-bar"
    :class="{ 'has-tab-bar': showTabBar }"
  >
    <app-bar title="Privacy" :show-back-button="true" />
    <div class="container">
      <h1>Privacyverklaring</h1>

      <p>
        Inviplay respecteert jouw privacy en draagt er zorg voor dat de
        persoonlijke informatie die je aan ons verstrekt, vertrouwelijk en in
        overeenstemming met de toepasselijke wet- en regelgeving, waaronder de
        Algemene Verordening Gegevensbescherming (AVG), wordt behandeld. In deze
        privacyverklaring geven wij informatie over hoe wij omgaan met je
        persoonsgegevens op onze website en in onze mobiele apps.
      </p>

      <h2>Welke gegevens en welk doel</h2>
      <p>
        Wij verwerken je persoonsgegevens uitsluitend voor het doel waarvoor je
        ze aan ons verstrekt en wij verwerken niet meer gegevens dan daarvoor
        nodig zijn. Het gaat om gegevens die je zelf opgeeft (zoals je naam,
        e-mailadres, postcode, profielfoto en sportvoorkeuren) en gegevens die
        ontstaan door je gebruik van het platform (zoals je aanmeldingen voor
        activiteiten, boekingen, berichten en betalingen). Je persoonsgegevens
        worden door ons verwerkt ten behoeve van de volgende doeleinden:
      </p>
      <ul class="list-inside list-disc my-2">
        <li>
          Om mensen via het platform met elkaar te verbinden om te sporten
        </li>
        <li>
          Om je te kunnen uitnodigen voor de sporten waarin jij geïnteresseerd
          bent
        </li>
        <li>
          Om aanmeldingen, boekingen en betalingen voor activiteiten af te
          handelen
        </li>
        <li>
          Om te communiceren over sportactiviteiten en nieuwe mogelijkheden op
          Inviplay
        </li>
        <li>
          Om het platform te beveiligen, verbeteren en fouten op te sporen
        </li>
      </ul>
      <p class="mt-4">
        Omdat wij mensen willen stimuleren zich aan te melden voor activiteiten
        laten we zien hoeveel deelnemers al meedoen aan een activiteit. Om jouw
        privacy te beschermen tonen we hierbij geen achternamen, alleen je
        voornaam en de eerste letter van je achternaam. De organisator van een
        activiteit ziet de achternamen wel.
      </p>
      <p class="mt-4">
        De nieuwsberichten van Inviplay en uitnodigingen voor sportactiviteiten
        worden alleen verzonden als je je daarvoor hebt aangemeld. Afmelden kan
        je eenvoudig zelf via de link onderaan de nieuwsberichten, of via je
        profiel. Pushmeldingen in de app kun je aan- en uitzetten in je
        profielinstellingen of via de instellingen van je telefoon.
      </p>

      <h2>Financiële gegevens</h2>
      <p>
        Om betalingen af te handelen tussen partijen moet een organisatie een
        vergunning als betaaldienstverlener hebben. Inviplay heeft die zelf niet
        en werkt daarom samen met Online Payment Platform (OPP). OPP heeft een
        licentie als betaaldienstverlener van De Nederlandsche Bank en verwerkt
        alle betalingen op Inviplay, zoals iDEAL- en PayPal-betalingen.
      </p>
      <p class="mt-4">
        Om bedragen te kunnen uitbetalen op jouw rekening heeft Online Payment
        Platform een bevestiging van jouw bankgegevens en ID nodig. Zij zijn als
        betaaldienstverlener wettelijk verplicht om een verificatie te doen van
        de mensen aan wie zij geld uitkeren. Dat heet KYC (&ldquo;know your
        customer&rdquo;). Als je dus uitbetalingen wil laten doen via Inviplay
        word je doorgestuurd naar Online Payment Platform voor een ID-check.
      </p>

      <p class="mt-4">
        Inviplay slaat jouw bankgegevens of ID niet zelf op. Online Payment
        Platform is gespecialiseerd in het verwerken van gevoelige informatie.
        Zij versleutelen de gegevens en bewaren deze op extra beveiligde
        servers. Je gegevens worden alleen gebruikt om je identiteit vast te
        stellen. Zie ook hun beleid:
        <a
          href="https://onlinepaymentplatform.com/nl/privacy"
          target="_blank"
          class="link"
        >
          https://onlinepaymentplatform.com/nl/privacy
        </a>
        .
      </p>

      <h2>Verstrekking aan derden</h2>
      <p>
        De gegevens die je aan ons geeft kunnen wij aan derde partijen
        verstrekken als dit noodzakelijk is voor de uitvoering van de hierboven
        beschreven doeleinden.
      </p>
      <p class="mt-4">
        Op het moment dat je een sportlocatie boekt hebben beheerders van die
        locatie inzage in een aantal persoonsgegevens (voor- en achternaam)
        zodat ze weten wie er gebruik maakt van hun sportlocatie. Organisatoren
        van activiteiten hebben inzicht in deelnemerslijsten (voor- en
        achternaam en e-mailadres), zodat ze deelnemers kunnen bereiken mocht
        dat nodig zijn.
      </p>
      <p class="mt-4">
        Daarnaast maken wij gebruik van dienstverleners (verwerkers) die
        gegevens voor ons verwerken:
      </p>
      <ul class="list-inside list-disc my-2">
        <li>Online Payment Platform — betalingen en uitbetalingen</li>
        <li>Microsoft Azure — hosting van onze servers en database</li>
        <li>Netlify — hosting van de website</li>
        <li>Mailjet — het versturen van e-mails</li>
        <li>PostHog — gebruiksstatistieken (servers in de EU)</li>
        <li>Google Analytics — webstatistieken</li>
        <li>Meta (Facebook/Instagram) — het meten van advertenties</li>
        <li>Sentry — het registreren van technische fouten</li>
      </ul>
      <p class="mt-4">
        Wij maken met deze partijen de nodige afspraken
        (verwerkersovereenkomsten) om de beveiliging van je persoonsgegevens te
        waarborgen. Waar mogelijk worden je gegevens binnen de EU verwerkt.
        Enkele dienstverleners (zoals Google, Meta en Sentry) kunnen gegevens
        buiten de EU verwerken; met deze partijen gelden passende waarborgen,
        zoals certificering onder het EU-VS Data Privacy Framework. Verder
        zullen wij de door jou verstrekte gegevens niet aan andere partijen
        verstrekken, tenzij dit wettelijk verplicht is.
      </p>

      <h2>Bewaartermijn</h2>
      <p>
        Wij bewaren je persoonsgegevens niet langer dan noodzakelijk voor het
        doel waarvoor deze zijn verstrekt dan wel op grond van de wet is
        vereist. Als je jouw account opheft, verwijderen we je persoonsgegevens.
        Gegevens over betalingen kunnen langer bewaard blijven voor zover wij
        daartoe wettelijk verplicht zijn (bijvoorbeeld de fiscale bewaarplicht).
      </p>

      <h2>Beveiliging</h2>
      <p>
        Wij nemen de bescherming van je gegevens serieus en hebben passende
        technische en organisatorische maatregelen genomen om je
        persoonsgegevens te beschermen.
      </p>

      <h2>Rechten omtrent je gegevens</h2>
      <p>
        Met betrekking tot de persoonsgegevens die wij van je verwerken heb je
        de volgende rechten:
      </p>
      <ul class="list-inside list-disc">
        <li>Recht op inzage</li>
        <li>Recht op rectificatie</li>
        <li>Recht op wissing (vergetelheid)</li>
        <li>Recht op beperking van de verwerking</li>
        <li>Recht op overdraagbaarheid (dataportabiliteit)</li>
        <li>Recht van bezwaar</li>
        <li>Recht op intrekking toestemming</li>
        <li>Recht om een klacht in te dienen</li>
      </ul>

      <h2>Links naar andere websites en social media</h2>
      <p>
        Op onze website is een aantal verwijzingen naar websites van andere
        organisaties te vinden. Wij hebben geen controle over deze externe
        websites en zijn niet aansprakelijk voor de manier waarop deze partijen
        met persoonsgegevens omgaan.
      </p>

      <h2>Cookies en webstatistieken</h2>
      <p>
        Deze website maakt gebruik van cookies. Cookies zijn kleine
        (tekst)bestanden die een webpaginaserver bij bezoek aan een webpagina op
        je computer, tablet of ander elektronisch apparaat (hierna
        &ldquo;computer&rdquo;) plaatst. Doordat een cookie op je computer
        staat, kan de webpaginaserver je computer herkennen.
      </p>
      <p class="mt-4">
        Noodzakelijke cookies (bijvoorbeeld om ingelogd te blijven) plaatsen we
        altijd. Cookies voor statistieken (PostHog en Google Analytics) en het
        meten van advertenties (Meta) plaatsen we alleen nadat je die hebt
        geaccepteerd via de cookiemelding. Kies je voor weigeren, dan worden
        deze cookies niet geplaatst. Je kunt je keuze hieronder altijd wijzigen:
      </p>
      <p class="mt-2">
        <button class="link underline" @click="changeCookiePreferences">
          Cookievoorkeuren wijzigen
        </button>
      </p>
      <p class="mt-4">
        Cookies hebben een bepaalde geldigheidsduur vanaf het moment dat ze op
        een computer worden geplaatst. Nadat de geldigheidsduur verstrijkt,
        wordt de cookie verwijderd door je browser. Voor zover wij met behulp
        van cookies persoonsgegevens van je verzamelen, verwerken wij die
        conform deze privacyverklaring. Je kunt daarnaast je browser zo
        instellen dat er geen cookies worden opgeslagen of dat alle cookies
        verwijderd worden bij het afsluiten van je browser. Meer informatie over
        hoe je cookies kunt beheren lees je op de website van de
        <a
          href="https://www.consumentenbond.nl/internet-privacy/cookies-verwijderen"
          target="_blank"
        >
          Consumentenbond
        </a>
        .
      </p>

      <h2>Google Analytics</h2>
      <p>
        Wij maken gebruik van Google Analytics om bij te houden hoe onze
        bezoekers de website gebruiken. Voor dit doel worden cookies geplaatst.
        Deze informatie wordt overgebracht naar en door Google. Google gebruikt
        deze informatie om bij te houden hoe onze website gebruikt wordt en om
        rapporten over de website aan ons te kunnen verstrekken. Het is Google
        niet toegestaan deze gegevens aan derden te verstrekken of voor andere
        Google-diensten in te zetten. Lees voor meer informatie het
        <a href="https://policies.google.com/privacy?hl=nl" target="_blank">
          privacybeleid van Google
        </a>
        . Zie
        <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">
          hier
        </a>
        voor meer informatie over de opt-out-regeling van Google.
      </p>

      <h2>PostHog</h2>
      <p>
        Wij gebruiken PostHog om te analyseren hoe het platform wordt gebruikt,
        zodat we Inviplay kunnen verbeteren. Denk aan welke pagina's worden
        bezocht en welke functies worden gebruikt. Alleen als je cookies hebt
        geaccepteerd wordt dit gebruik gekoppeld aan je account (als je bent
        ingelogd). Zonder akkoord meten we uitsluitend anoniem en zonder
        cookies: er wordt dan niets op je apparaat opgeslagen en je bezoek is
        niet tot jou als persoon te herleiden. PostHog verwerkt deze gegevens
        voor ons op servers binnen de EU. Zie ook het
        <a href="https://posthog.com/privacy" target="_blank">
          privacybeleid van PostHog
        </a>
        .
      </p>

      <h2>Meta (Facebook en Instagram)</h2>
      <p>
        Wij adverteren op Facebook en Instagram. Om het effect van die
        advertenties te meten en om onze doelgroep beter te bereiken, delen wij
        bepaalde gebeurtenissen (zoals een registratie) met Meta.
        Persoonsgegevens zoals je e-mailadres worden daarbij niet leesbaar
        gedeeld, maar eerst versleuteld (gehasht). Meta kan deze gegevens alleen
        koppelen aan personen die zelf een Facebook- of Instagram-account
        hebben. Wil je liever geen advertenties op basis van je interesses? Dat
        kun je instellen in je
        <a href="https://www.facebook.com/ds/preferences/edit/" target="_blank">
          advertentievoorkeuren bij Facebook
        </a>
        . Meer informatie vind je in het
        <a href="https://nl-nl.facebook.com/policies/cookies/" target="_blank">
          cookiebeleid van Meta
        </a>
        .
      </p>

      <h2>Sentry</h2>
      <p>
        Om technische fouten op het platform snel te kunnen opsporen en oplossen
        gebruiken wij Sentry. Als er iets misgaat, wordt technische informatie
        over de fout (zoals het type apparaat en browser) naar Sentry gestuurd.
        Deze informatie gebruiken wij uitsluitend om fouten te verhelpen.
      </p>

      <h2>Inviplay is niet perfect</h2>
      <p>
        Mocht je een klacht hebben over de verwerking van je persoonsgegevens
        dan vragen wij je hierover direct contact met ons op te nemen. Wij
        proberen er dan samen met je uit te komen. Daarnaast heb je altijd het
        recht een klacht in te dienen bij de toezichthouder:
        <a
          target="_blank"
          href="https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons"
        >
          Autoriteit Persoonsgegevens
        </a>
        .
      </p>

      <h2>Wijzigingen</h2>
      <p>
        Ons privacybeleid is afgestemd op het gebruik van en de mogelijkheden op
        dit platform. Wij behouden ons het recht voor om deze privacyverklaring
        aan te passen. Het is daarom raadzaam om regelmatig deze
        privacyverklaring te raadplegen.
      </p>

      <h2>Contact</h2>
      <p>
        Indien je na het lezen van deze privacyverklaring vragen hebt, kun je
        hierover contact met ons opnemen via onderstaande contactgegevens:
      </p>

      <p class="mt-4">
        Inviplay B.V.
        <br />
        Prinses Beatrixlaan 26
        <br />
        3554 JK Utrecht
        <br />
        <a href="mailto:contact@inviplay.nl">contact@inviplay.nl</a>
      </p>

      <p class="mt-4 text-sm">
        <em>Laatst bijgewerkt: 02/09/2026</em>
      </p>
    </div>
    <tab-bar v-if="showTabBar" selected="profile" />
  </div>
</template>

<script>
import AppBar from '@/components/AppBar'
import TabBar from '@/components/TabBar'
import { resetConsent } from '@/utils/consent'

export default {
  name: 'PrivacyPolicy',
  components: {
    AppBar,
    TabBar
  },
  data() {
    return {
      showTabBar: this.$route.query.hideTabBar !== 'true'
    }
  },
  methods: {
    changeCookiePreferences() {
      resetConsent()
      window.location.reload()
    }
  }
}
</script>

<style scoped></style>
